import { Card, CardBody, Col, ListGroup, ListGroupItem } from "reactstrap";
import { Alerts, CART, Chart, CHECKOUT, FlushListTitle } from "../../../Constants/Constants";
import { FlushListSubTitle } from "../../../Data/UiKits/Lists";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const FlushList = () => {
  return (
    <Col xl="4" md="12">
      <Card>
        <CommonCardHeader title={FlushListTitle} span={FlushListSubTitle} />
        <CardBody>
          <ListGroup flush>
            <ListGroupItem><i className="icofont icofont-chart-histogram-alt"> </i>{Chart}</ListGroupItem>
            <ListGroupItem><i className="icofont icofont-warning"> </i>{Alerts}</ListGroupItem>
            <ListGroupItem><i className="icofont icofont-cart"> </i>{CART}</ListGroupItem>
            <ListGroupItem><i className="icofont icofont-checked"> </i>{CHECKOUT}</ListGroupItem>
          </ListGroup>
        </CardBody>
      </Card>
    </Col>
  );
};
export default FlushList;
